const vThrottleClick = {
  mounted(el, binding) {
    const { arg, modifiers } = binding;
    
    // 默认节流时间为2000毫秒，可以通过参数修改
    const throttleTime = arg ? parseInt(arg) : 2000;
    
    let lastClickTime = 0;
    
    const clickHandler = (event) => {
      const currentTime = new Date().getTime();
      
      if (currentTime - lastClickTime >= throttleTime) {
        lastClickTime = currentTime;
        
        // 执行绑定的函数
        if (typeof binding.value === 'function') {
          binding.value(event);
        }
      }
    };
    
    // 添加点击事件监听器
    el.addEventListener('click', clickHandler);
    
    // 存储 clickHandler 以便在 unmounted 钩子中移除
    el._throttleClickHandler = clickHandler;
  },
  
  unmounted(el) {
    // 移除事件监听器以防止内存泄漏
    el.removeEventListener('click', el._throttleClickHandler);
    delete el._throttleClickHandler;
  }
};

export default vThrottleClick;